import { createContext, useContext, useEffect, useState } from "react";

const KEY = "ds_shortlist";
const ShortlistContext = createContext({ items: [], has: () => false, toggle: () => {}, remove: () => {}, clear: () => {} });

const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
};

export const ShortlistProvider = ({ children }) => {
  const [items, setItems] = useState(read);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const has = (id) => items.some((i) => i.id === id);
  const toggle = (listing) =>
    setItems((cur) =>
      cur.some((i) => i.id === listing.id)
        ? cur.filter((i) => i.id !== listing.id)
        : [...cur, {
            id: listing.id, reference: listing.reference, title: listing.title, community: listing.community,
            price: listing.price, price_period: listing.price_period, purpose: listing.purpose,
            bedrooms: listing.bedrooms, bathrooms: listing.bathrooms, area_sqft: listing.area_sqft,
            cover_image: listing.cover_image || (listing.photos || [])[0],
          }]
    );
  const remove = (id) => setItems((cur) => cur.filter((i) => i.id !== id));
  const clear = () => setItems([]);

  return <ShortlistContext.Provider value={{ items, has, toggle, remove, clear }}>{children}</ShortlistContext.Provider>;
};

export const useShortlist = () => useContext(ShortlistContext);
